module.exports = __webpack_public_path__ + "media/images/flags/16/Cote-dIvoire-4410882939f22a60a5b927adb42a0943.png";